<template>
    <div class="economy-learning">
        
        <content-switch
        :items="switchItems"
        :selectedItem="selectedItem"
        :counts="counts"
        @selectItem="handleSelectItem($event)" />

        <revenue-and-costs v-show="selectedItem === 'revenueAndCosts'" />
        <ebitda v-show="selectedItem === 'ebitda'" />
        <budget-followup v-show="selectedItem === 'budgetFollowup'" />
        <compare v-if="selectedItem === 'compare'" />
        <potential v-show="selectedItem === 'potential'" />
        <keyFigures v-show="selectedItem === 'keyFigures'" />
        <materials v-show="selectedItem === 'materials'" />
        <all-invoices v-show="selectedItem === 'allInvoices'" @finishedLoading="updateCount('allInvoices', $event)" />

    </div>
</template>

<script>
import revenueAndCosts from './learning/revenueAndCosts.vue'
import ebitda from './learning/ebitda.vue'
import compare from './learning/compare.vue'
import potential from './learning/potential.vue'
import keyFigures from './learning/keyFigures.vue'
import materials from './learning/materials.vue'
import budgetFollowup from './learning/budgetFollowup.vue'

export default {
    components: {
        revenueAndCosts,
        ebitda,
        budgetFollowup,
        compare,
        potential,
        keyFigures,
        materials
    },
    data () {
        return {
            selectedItem: 'ebitda',
            counts: {
                EconomyOperationsUnbilledProjects: null,
                EconomyOperationsExceededPayments: null,
                allInvoices: null
            },
            switchItems: [
                {
                    name: 'EBITDA',
                    slug: 'ebitda',
                    dTooltip: 'economy.ebitda'
                },
                {
                    name: 'Værdikæde',
                    slug: 'revenueAndCosts'
                },
                {
                    name: 'Nøgletal',
                    slug: 'keyFigures'
                },
                {
                    name: 'Vareforbrug',
                    slug: 'materials'
                },
                {
                    name: 'Alle fakturaer og kreditnotaer',
                    slug: 'allInvoices'
                }
                /* {
                    name: 'Virksomhedens potentiale',
                    slug: 'potential',
                    comingsoon: false
                }, */
            ]
        }
    },
    methods: {
        updateCount (slug, event) {
            this.counts[slug] = event
        },
        handleSelectItem (item) {
            this.selectedItem = item
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            })
        }
    },
    mounted () {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab
        }
        this.$store.state.view = 'learning'
        if (this.$store.state.config.availableDepartments.length > 3) {
            this.switchItems.splice(4, 0, {name: 'Sammenlign afdelinger', slug: 'compare'})
        }
        // if (this.$auth.user().roles[0].name === 'super-admin') {
            this.switchItems.splice(1, 0, {name: 'Budgetopfølgning', slug: 'budgetFollowup'})
        // }
    }
}
</script>



// WEBPACK FOOTER //
// learning.vue?c5a3fe7c